/**
 * A verification URL without ?n= falls back to this chain. It was hardcoded to
 * the 6DO testnet, which is right for staging and wrong for production
 * (mainnet 2477) — so prod must set NEXT_PUBLIC_DEFAULT_NETWORK_ID.
 */
const DEFAULT_NETWORK_ID = process.env.NEXT_PUBLIC_DEFAULT_NETWORK_ID || '24772477';

export function parseCertificateUrl(raw: string): {
  contract: string | null;
  tokenId: string | null;
  networkId: string | null;
} {
  try {
    const hasProtocol = raw.startsWith('http://') || raw.startsWith('https://');
    const url = new URL(hasProtocol ? raw : 'https://' + raw);

    const segments = url.pathname.split('/').filter(Boolean);
    const contract =
      segments.find((segment) => /^0x[a-fA-F0-9]{40}$/.test(segment)) || null;
    const tokenId = url.searchParams.get('a');
    const networkId = url.searchParams.get('n') || DEFAULT_NETWORK_ID;

    if (!contract || !tokenId || !networkId) throw new Error('Missing params');

    return { contract, tokenId, networkId };
  } catch {
    return { contract: null, tokenId: null, networkId: null };
  }
}

export function extractShortCode(raw: string): { shortCode: string; qrUrl: string } | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;

  try {
    const url = new URL(trimmed.startsWith('http') ? trimmed : `https://${trimmed}`);
    const segments = url.pathname.split('/').filter(Boolean);
    if (segments.length === 1 && /^[A-Za-z0-9_-]{2,20}$/.test(segments[0])) {
      return { shortCode: segments[0], qrUrl: url.toString() };
    }
    return null;
  } catch {
    return null;
  }
}